import { customAlphabet, nanoid } from 'nanoid';
import { v4, v5 } from 'uuid';
/** Generate a random unique domain-safe name (1% chance of collision in 1000 years) */
export const randomDomainName = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 11);
export const generateCustomId = nanoid;
export const uuidv5 = v5;
export const uuid = v4;
